/* eslint-disable */
import request from './helpers'

export function getRequestList (size, page, status) {
    return request ({
        url: '/api/v1/request/query',
        method: 'get',
        params: {
            size,
            page,
            status
        }
    })
}

export function createRequest (data) {
    return request ({
        url: '/api/v1/request',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteRequest (id) {
    return request ({
        url: '/api/v1/request/' + id,
        method: 'delete'
    })
}

export function getRequestById (id) {
    return request ({
        url: '/api/v1/request/' + id,
        method: 'get'
    })
}

export function updateRequest (id, data) {
    return request ({
        url: '/api/v1/request/' + id,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function submitRequest (id) {
    return request ({
        url: '/api/v1/request/' + id + '/submit',
        method: 'get'
    })
}

export function submitRequests (data) {
    return request ({
        url: '/api/v1/request/submit',
        method: 'post',
        data
    })
}

export function approveRequest (id) {
    return request ({
        url: '/api/v1/request/' + id + '/approve',
        method: 'get'
    })
}

export function approveRequests (data) {
    return request ({
        url: '/api/v1/request/approve',
        method: 'post',
        data
    })
}

export function executeRequest (id) {
    return request ({
        url: '/api/v1/request/' + id + '/execute',
        method: 'get'
    })
}

export function executeRequests (data) {
    return request ({
        url: '/api/v1/request/execute',
        method: 'post',
        data
    })
}

export function getRequestExtraInfo (type) {
    return request ({
        url: '/api/v1/request/extraInfo',
        method: 'get',
        params: {
            type
        }
    })
}

export function rejectRequest (id, message) {
    return request ({
        url: '/api/v1/request/' + id + '/reject',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            message
        }
    })
}
